// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/buefy.css
// module id = 15
// module chunks = 0